import { getAuthHeaders } from './auth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const enrollSelfie = async (imageBase64, angle) => {
  const response = await fetch(`${API_URL}/api/enroll/selfie`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({
      image_base64: imageBase64,
      angle: angle
    })
  });
  
  if (!response.ok) {
    let errorMessage = 'Enrollment failed';
    try {
      const error = await response.json();
      errorMessage = error.detail || errorMessage;
    } catch (e) { /* parse error */ }
    throw new Error(errorMessage);
  }
  
  return response.json();
};

export const getEnrollmentStatus = async () => {
  const response = await fetch(`${API_URL}/api/enroll/status`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    throw new Error('Failed to get enrollment status');
  }
  
  return response.json();
};

export const resetEnrollment = async () => {
  const response = await fetch(`${API_URL}/api/enroll/reset`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    let errorMessage = 'Failed to reset enrollment';
    try {
      const error = await response.json();
      errorMessage = error.detail || errorMessage;
    } catch (e) { /* parse error */ }
    throw new Error(errorMessage);
  }
  
  return response.json();
};
